import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import * as conf from "qpr-base/configuration";
import { initReactI18next } from "react-i18next";
import { getFile } from "./qpr-base/api/files";

const initializeLanguages = () => {
  // The language switch UI has been removed — the app is English-only now. Any user
  // who previously switched to Arabic (still in localStorage from before) gets forced
  // back to English here so they land in the app in English going forward.
  const currentlang = localStorage.getItem("i18nextLng");
  if (currentlang && currentlang !== "en") {
    localStorage.setItem("i18nextLng", "en");
  }
  if (currentlang && !conf.System.settings.languages.includes(currentlang))
    localStorage.removeItem("i18nextLng"); // remove unsupported lang from localstorage

  const fallbackLng =
    conf.System.settings.languages?.length > 0
      ? conf.System.settings.languages[0]
      : "en";
  const lngDetector = new LanguageDetector(null, {
    // order and from where user language should be detected
    order: ["localStorage"],
  });
  i18n
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
    .use(HttpApi)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(lngDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
      ns: ["2023"], // must be more dynamic to add modules ns
      defaultNS: "2023",
      backend: {
        request: (
          options: any,
          url: any,
          payload: any,
          callback: (arg0: any, arg1: { data: any; status: number }) => void
        ) => {
          try {
            getFile(
              `/translations/${
                localStorage.getItem("i18nextLng") || fallbackLng
              }.json`
            ).then((result: any) => {
              callback(null, {
                data: result.data,
                status: 200,
              });
            });
          } catch (e) {
            console.error(e);
            callback(null, {
              data: null,
              status: 500,
            });
          }
        },
      },
      debug: false,
      load: "currentOnly",
      fallbackLng,
      partialBundledLanguages: true,
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
    });
};

i18n.on("languageChanged", (lng) => {});

export default initializeLanguages;
